import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.array.find";
import _typeof from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _objectSpread from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import OPZPage from "..//OPZPage";
import { emptyFilter } from '@/filters';
import { deepCloneForce } from '@/utils';
import { dicts } from '@/config';
// import OPZPage from '../OPZPage'
export default {
  components: {
    OPZPage: OPZPage
  },
  props: {
    // 表头配置项
    columns: {
      type: Array,
      required: true
    },
    // 表格数据
    tableData: {
      type: Array,
      default: null
    },
    // 是否显示索引
    seq: Boolean,
    // 请求方法
    requestMethod: {
      type: Function,
      default: null
    },
    // 请求参数
    requestParams: {
      type: Object,
      default: function _default() {}
    },
    // 表格大小
    size: {
      type: String,
      default: 'small'
    },
    // 是否选择
    select: Boolean,
    // 选择类型 multiple多选/radio单选
    selectType: {
      type: String,
      default: 'multiple'
    },
    // 是否显示表头
    showHeader: {
      type: Boolean,
      default: true
    },
    // 全局对齐
    align: {
      type: String,
      default: "center"
    },
    // 列最小宽
    columnMinWidth: {
      type: String,
      default: "100px"
    },
    // 是否启用操作列
    tool: Boolean,
    // 操作列位置
    toolPosition: {
      type: String,
      default: 'left'
    },
    // 操作列宽度
    toolWidth: {
      type: Number,
      default: 80
    },
    // 下拉/复选框数据
    selectOptions: {
      type: Object,
      default: null
    },
    // 头部样式
    cellHeaderStyle: {
      type: Function,
      default: null
    },
    // 单元格样式
    cellStyle: {
      type: Function,
      default: null
    },
    // 字典api其他参数配置
    dictOtherApis: {
      type: Object,
      default: function _default() {}
    },
    // 校验数据
    rules: {
      type: Object,
      default: null
    },
    // 业务表格名字
    name: {
      type: String,
      default: ''
    },
    // 表格容器是否flex布局
    isFlex: {
      type: Boolean,
      default: false
    },
    // 首次加载是否请求数据（requestMethod不为空时）
    isFirstReq: {
      type: Boolean,
      default: true
    },
    // 内容过长超出显示tooltip
    showOverflowTooltip: {
      type: Boolean,
      default: false
    },
    // tooltip 主题
    tooltipEffect: {
      type: String,
      default: 'light'
    },
    // 是否开启序号列插槽
    isSeqnode: {
      type: Boolean,
      default: false
    },
    // 序号列宽度
    seqWidth: {
      type: [Number, String],
      default: 50
    },
    //  是否开启统计总数
    isPushData: {
      type: Boolean,
      default: false
    },
    //  开启统计总数开关后，传入需要统计的字段
    totalList: {
      type: [Object, String],
      default: function _default() {}
    },
    //  开启统计总数开关后，在什么位置显示合计字样
    filterList: {
      type: Object,
      default: function _default() {}
    },
    // 是否开启懒加载
    lazy: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      data: [],
      // 选中的数据
      selectData: [],
      // 页数
      pageNo: 1,
      // 每一页条数
      pageSize: 10,
      // 总数
      dataTotal: 0,
      // 加载
      loading: false,
      // 请求参数
      localRequestParams: {},
      // 缓存请求参数
      cacheRequestParams: {},
      // 后台返回的数据
      responseData: null
    };
  },
  computed: {},
  watch: {
    requestParams: {
      handler: function handler(val) {
        this.localRequestParams = val;
      },
      deep: true,
      immediate: true
    }
  },
  created: function created() {
    this.init();
    if (this.tableData && this.tableData.length > 0) {
      // 表格最后一行添加汇总数据
      if (this.isPushData) {
        this.handleTotalData(this.tableData);
      }
    }
  },
  methods: {
    // 初始化
    init: function init() {
      this.isFirstReq && this.handleGetRequestData();
    },
    //  统计数量
    statisticalQuantity: function statisticalQuantity(data) {
      if (this.isPushData) {
        var newObj = this.filterList;
        for (var obj in this.totalList) {
          this.totalList[obj] = this.countTotal(data, obj);
        }
        Object.assign(newObj, this.totalList);
        data.push(newObj);
      }
    },
    // 获取数据
    handleGetRequestData: function handleGetRequestData() {
      var _this = this;
      if (!this.requestMethod) return;
      this.loading = true;
      var params = deepCloneForce(this.localRequestParams);
      this.cacheRequestParams = deepCloneForce(this.localRequestParams);
      // console.log('x', params)
      this.requestMethod({
        current: this.pageNo,
        size: this.pageSize,
        selectParameter: _objectSpread({}, params)
      }).then(function (res) {
        _this.responseData = res;
        _this.loading = false;
        _this.pageNo = res.data.current;
        _this.dataTotal = res.data.total;
        _this.data = res.data.records || [];

        // 表格最后一行添加汇总数据
        if (_this.isPushData) {
          _this.handleTotalData(_this.data);
        }
        _this.__requestFinishCallBack();
      }).catch(function (_) {
        _this.loading = false;
        _this.__requestFinishCallBack();
      });
    },
    // 添加样式
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row;
      if (row.style) {
        return 'not-finish';
      }
      return '';
    },
    // 数据合计
    countTotal: function countTotal(arr, keyName) {
      var $total = 0;
      $total = arr.reduce(function (total, currentValue, currentIndex, arr) {
        return Number(currentValue[keyName] ? total + currentValue[keyName] : total);
      }, 0);
      return $total;
    },
    // 请求后的回调
    __requestFinishCallBack: function __requestFinishCallBack() {
      this.$emit('requestCallBackChange', this.data, this.responseData);
    },
    // 监听每页条数修改
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.handleRefresh();
    },
    // 监听分页页数修改
    handleCurrPageChange: function handleCurrPageChange(page) {
      var _this2 = this;
      this.pageNo = page;
      this.$nextTick(function () {
        return _this2.handleGetRequestData();
      });
    },
    // 刷新数据
    handleRefresh: function handleRefresh() {
      var _this3 = this;
      this.pageNo = 1;
      this.$nextTick(function () {
        return _this3.handleGetRequestData();
      });
    },
    // 格式化单元格内容
    handleFormatterCell: function handleFormatterCell(args, formatter) {
      var _args$ = args[0],
        cellValue = _args$.cellValue,
        row = _args$.row;
      if (!cellValue) return emptyFilter(cellValue);
      if (!formatter) return cellValue;
      var formatterType = _typeof(formatter);
      if (formatterType === 'function') return formatter(cellValue, row);
      if (formatterType === 'string') {
        return this.handleSetFormatterCell(formatter, cellValue);
      }
    },
    // 根据formatter类型设置单元格内容
    handleSetFormatterCell: function handleSetFormatterCell(formatter, cellValue) {
      if (cellValue === undefined) return emptyFilter(cellValue);
      if (cellValue === null) return emptyFilter(cellValue);
      switch (formatter) {
        case 'price':
          return "\uFFE5 ".concat(cellValue);
        case 'rate':
          return "".concat(cellValue, "%");
        default:
          return "".concat(formatter, " ").concat(cellValue);
      }
    },
    // 处理单元格内容
    handleSetCellTextNode: function handleSetCellTextNode(scope, col) {
      var row = scope.row,
        column = scope.column;
      var config = col.config;
      if (!col.formatter) {
        // 渲染嵌套字段
        if (config && config.subProp) {
          if (Array.isArray(row[config.subProp])) {
            return row[config.subProp].find(function (i) {
              return i[config.subKey] === column.property;
            })[config.subValKey];
          }
          if (Object.prototype.toString.call(row[config.subProp]) === '[object Object]') {
            return row[config.subProp][config.subKey];
          }
          return row[config.subProp];
        }
        // 渲染不同字段
        return row[column.property];
      }
      return this.handleFormatterCell([{
        cellValue: row[column.property],
        row: row
      }], col.formatter);
    },
    // html格式化内容
    handleHtmlFormatter: function handleHtmlFormatter(_ref2, col) {
      var row = _ref2.row,
        column = _ref2.column;
      if (!col.htmlFormatter) return row[column.property];
      return col.htmlFormatter(row[column.property], row);
    },
    // 监听表格选择
    handleSelectChange: function handleSelectChange(sel, row) {
      this.selectData = sel;
      this.$emit('selectChange', sel);
      this.$emit('selectChange2', {
        sel: sel,
        row: row
      });
    },
    // 监听表格全选
    handleSelectAllChange: function handleSelectAllChange(sel, row) {
      this.selectData = sel;
      this.$emit('selectChange', sel);
      this.$emit('selectAllChange', sel);
    },
    // 监听行点击
    handleRowClick: function handleRowClick(row) {
      if (this.select && this.selectType === 'radio') {
        this.selectData = row;
        this.$emit('selectChange', row);
      }
    },
    // 监听input编辑
    handleEditInputChange: function handleEditInputChange() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      this.$emit.apply(this, ['edit'].concat(args));
    },
    // 监听select编辑
    handleEditSelectChange: function handleEditSelectChange() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      this.$emit.apply(this, ['edit'].concat(args));
    },
    // 监听inputNumber编辑
    handleEditInputNumberChange: function handleEditInputNumberChange() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      this.$emit.apply(this, ['edit'].concat(args));
    },
    // 监听字典下拉编辑
    handleDictChange: function handleDictChange() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      this.$emit.apply(this, ['edit'].concat(args));
    },
    // 监听富文本编辑
    handleEditorChange: function handleEditorChange(val, _ref3) {
      var _this4 = this;
      var $index = _ref3.$index,
        row = _ref3.row,
        column = _ref3.column;
      this.$nextTick(function () {
        _this4.$set(row, column.property, val);
      });
    },
    // 监听编辑单元格的聚焦事件
    handleEditCellFocus: function handleEditCellFocus(_, args) {
      this.$emit('editCellFocusChange', args);
    },
    // 获取选中的数据
    __getSelections: function __getSelections() {
      return this.selectData;
    },
    // 清空选择的数据
    __clearSelections: function __clearSelections() {
      this.$refs.table.clearSelection();
      this.selectData = [];
    },
    // 设置图片URL
    __handleSetImgUrl: function __handleSetImgUrl(val, _ref4) {
      var config = _ref4.config;
      // TODO 废弃config的isImgFix属性
      // if (!config || !config.isImgFix) return val
      // return `${this.imgPrefix}${val}`
      if (typeof val !== 'string') return emptyFilter('');
      if (val.indexOf('http') > -1) return val;
      return "".concat(this.imgPrefix).concat(val);
    },
    // 设置表头样式
    __setHeaderCellStyle: function __setHeaderCellStyle(arg) {
      // 默认样式
      var _defaultStyles = {
        background: 'rgb(245, 247, 250)'
      };
      // 额外样式
      // eslint-disable-next-line no-unused-vars
      var _otherStyles = {};
      if (this.cellHeaderStyle) {
        _otherStyles = this.cellHeaderStyle(arg) || {};
      }
      return _objectSpread(_objectSpread({}, _defaultStyles), _otherStyles);
    },
    // 设置单元格样式
    __setCellStyle: function __setCellStyle(arg) {
      // 默认样式
      var _defaultStyles = {};
      // 额外样式
      // eslint-disable-next-line no-unused-vars
      var _otherStyles = {};
      if (this.cellStyle) {
        _otherStyles = this.cellStyle(arg) || {};
      }
      return _objectSpread(_objectSpread({}, _defaultStyles), _otherStyles);
    },
    // 设置单元格编辑是否禁用
    __setCellEditDisabled: function __setCellEditDisabled(_ref5, _ref6) {
      var editConfig = _ref5.editConfig;
      var row = _ref6.row;
      if (!editConfig) return;
      if (typeof editConfig.disabled === 'function') {
        return Boolean(editConfig.disabled(row));
      }
      return Boolean(editConfig.disabled);
    },
    // 渲染tag内容
    __setTagContent: function __setTagContent(_ref7, _ref8) {
      var prop = _ref7.prop,
        label = _ref7.label,
        tagformatter = _ref7.tagformatter;
      var row = _ref8.row;
      if (!tagformatter) return label;
      if (typeof tagformatter === 'string') return tagformatter;
      if (typeof tagformatter === 'function') return tagformatter(row[prop], row);
    },
    // 设置字典api
    __setDictApi: function __setDictApi(_ref9) {
      var prop = _ref9.prop,
        dictConfig = _ref9.dictConfig;
      var dictKey = dictConfig.dictKey,
        dictApi = dictConfig.dictApi;
      var otherApis = this.dictOtherApis && this.dictOtherApis[prop] ? "/".concat(this.dictOtherApis[prop]) : '';
      if (dictApi) return "".concat(dictApi).concat(otherApis);
      if (dictKey) return "".concat(dicts[dictKey]).concat(otherApis);
      return "".concat(dicts[prop]).concat(otherApis);
    },
    // 兼容上传文件数据格式
    __setUploadFilesArr: function __setUploadFilesArr(files) {
      return typeof files === 'string' ? files.split(',') : files;
    },
    // 是否显示校验星号
    __RequiredIconChoose: function __RequiredIconChoose(_ref10) {
      var prop = _ref10.property;
      if (!this.rules) return;
      if (!this.rules[prop]) return;
      var _propRuleType = Object.prototype.toString.call(this.rules[prop]);
      if (_propRuleType === '[object Object]' && !this.rules[prop].required) {
        return;
      }
      if (_propRuleType === '[object Array]' && this.rules[prop].every(function (i) {
        return !i.required;
      })) {
        return;
      }
      return true;
    },
    // 校验表格
    handleValidate: function handleValidate() {
      var _this5 = this;
      if (!this.rules || !Object.keys(this.rules).length) return;
      var _rules = {};
      var _tableData = this.tableData || this.data;
      // 兼容每一个校验的数据格式
      for (var key in this.rules) {
        var _propRuleType = Object.prototype.toString.call(this.rules[key]);
        _rules[key] = _propRuleType === '[object Object]' ? [this.rules[key]] : this.rules[key];
      }
      return new Promise(function (resolve, reject) {
        var _loop = function _loop(ruleKey) {
          // 必填项校验
          if (_rules[ruleKey].some(function (i) {
            return i.required;
          }) && _tableData.some(function (i) {
            return emptyFilter(i[ruleKey]) === '--';
          })) {
            var _errmsg = "".concat(_this5.name).concat(_rules[ruleKey].filter(function (i) {
              return i.required;
            })[0].message);
            _this5.$message.error({
              message: _errmsg
            });
            reject(_errmsg);
          }
          // 自定义校验
          _rules[ruleKey].filter(function (i) {
            return i.validate;
          }).forEach(function (item) {
            item.validate(_tableData).catch(function (err) {
              _this5.$message.error({
                message: err
              });
              reject(err);
            });
          });
        };
        for (var ruleKey in _rules) {
          _loop(ruleKey);
        }
        resolve(_tableData);
      });
    },
    // 处理统计数据
    handleTotalData: function handleTotalData(orignData) {
      var totalKeys = this.totalList === 'all' ? Object.fromEntries(Object.keys(orignData[0]).filter(function (key) {
        return !isNaN(Number(orignData[0][key]));
      }).map(function (i) {
        return Array(i);
      })) : Object.keys(this.totalList);
      var totalData = Object.keys(totalKeys).reduce(function (p, n) {
        n && (p[n] = orignData.reduce(function (kp, kn) {
          return kp + kn[n];
        }, 0));
        return p;
      }, {});
      orignData.push(_objectSpread(_objectSpread({}, totalData), this.filterList));
    }
  }
};